import { Locale } from "@/types/locale";

export const APP_NAME = "Alain Di Fabio | Full Stack Developer";
export const LOCALES = ["en", "it"] as const;
export const DEFAULT_LOCALE: Locale = "it";
export const BASE_URL =
  process.env.NEXT_PUBLIC_APP_ENV == "development"
    ? "http://localhost:3150"
    : "https://adf.dev";
